import React from 'react';
import Script from 'react-load-script';
import EricBright from '-!svg-react-loader!../img/ericbright.svg';

// Icons
import IconGithub from '-!svg-react-loader!../img/icon-github.svg';
import IconTwitter from '-!svg-react-loader!../img/icon-twitter.svg';
import IconLinkedin from '-!svg-react-loader!../img/icon-linkedin.svg';

export default class IndexPage extends React.Component {
  handleScriptLoad() {
    if (window.netlifyIdentity) {
      window.netlifyIdentity.on('init', user => {
        if (!user) {
          window.netlifyIdentity.on('login', () => {
            document.location.href = '/admin/';
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }

  render() {
    return (
      <section className="hero is-fullheight">
        <Script
          url="https://identity.netlify.com/v1/netlify-identity-widget.js"
          onLoad={this.handleScriptLoad.bind(this)}
        />
        <div className="hero-body">
          <div className="main-content">
            <h1 className="logo">
              <EricBright aria-label="Eric Bright"/>
            </h1>

            <div className="social-media">
              <a
                className="social-media-link"
                href="https://www.linkedin.com/in/eric-bright-37448670/"
                target="_blank"
              >
                <IconLinkedin aria-label="Eric Bright on LinkedIn" />
              </a>

              <a
                className="social-media-link"
                href="https://github.com/ericbdev"
                target="_blank"
              >
                <IconGithub aria-label="Eric Bright on Github" />
              </a>

              <a
                className="social-media-link"
                href="https://twitter.com/ericbdev"
                target="_blank"
              >
                <IconTwitter aria-label="Eric Bright on Twitter" />
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/index.js